import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiClipboard, FiChevronRight, FiInbox, FiAlertCircle, FiWifiOff } from 'react-icons/fi';
import DashboardLayout from '../../components/layout/DashboardLayout';
import SectionCard from '../../components/ui/SectionCard';
import ListItem from '../../components/ui/ListItem';
import EmptyState from '../../components/ui/EmptyState';
import { getSurveys } from '../../services/surveyService';
import { formatDate } from '../../utils/format';

export default function FormsListView() {
  const [surveys, setSurveys] = useState(null);
  const [error, setError] = useState(null);
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    let active = true;
    setError(null);
    setOffline(!navigator.onLine);
    getSurveys()
      .then((data) => {
        if (active) setSurveys(data);
      })
      .catch((err) => {
        if (!active) return;
        setSurveys([]);
        setError(err.message || 'No se pudieron cargar las encuestas.');
      });
    return () => {
      active = false;
    };
  }, []);

  const activeSurveys = surveys?.filter((s) => s.active) ?? [];

  return (
    <DashboardLayout title="Formularios" subtitle="Encuestas asignadas">
      {offline && !error && (
        <div className="form-error form-error--muted" role="status">
          <FiWifiOff /> Sin conexión: mostrando formularios guardados en este dispositivo.
        </div>
      )}

      {error && (
        <div className="form-error" role="alert">
          <FiAlertCircle /> {error}
        </div>
      )}

      <SectionCard title={surveys ? `Disponibles (${activeSurveys.length})` : 'Disponibles'}>
        {surveys === null && <EmptyState icon={<FiClipboard />} title="Cargando encuestas…" />}
        {surveys !== null && activeSurveys.length === 0 && !error && (
          <EmptyState
            icon={<FiInbox />}
            title="No tienes encuestas activas"
            description={
              offline
                ? 'No hay formularios guardados en este dispositivo todavía.'
                : 'Cuando se publique una nueva, aparecerá aquí.'
            }
          />
        )}
        {activeSurveys.map((survey) => (
          <ListItem
            key={survey.id}
            as={Link}
            to={`/data-entry/forms/${survey.id}`}
            icon={<FiClipboard />}
            title={survey.title}
            meta={`Fase ${survey.phase} · v${survey.version}${
              survey.startDate ? ` · desde ${formatDate(survey.startDate)}` : ''
            }`}
            right={<FiChevronRight />}
          />
        ))}
      </SectionCard>
    </DashboardLayout>
  );
}

